import { Link } from "react-router-dom";

const Header = () => {
  return (
<header className="bg-black text-orange-500 border-b-2 border-orange-500 py-4 px-4 sm:px-8">
  <div className="container mx-auto flex items-center justify-between gap-4">
    <Link to="/" className="text-2xl sm:text-4xl font-bold">WhisperBI</Link>
    <nav className="flex items-center gap-4 sm:gap-8">
      <Link to="/precios" className="text-lg sm:text-2xl text-orange-500 hover:text-orange-400 transition">
        Precios
      </Link>
      <Link to="/layautapp" className="text-lg sm:text-2xl text-orange-500 hover:text-orange-400 transition">
        Ingresar
      </Link>
    </nav>
  </div>
</header>

  );
};

export default Header;
